import { CommonResponse, FetchError } from '@api/common/types';
import { useBaseQuery } from '@api/hooks';

import { useAuthApiClient } from '@api/hooks/useAuthApiClient';
import { Brand, BrandsParams } from '../types';
import { getBrand, getBrands } from './api';

export const useBrands = (data: BrandsParams, enabled = true) => {
    const apiClient = useAuthApiClient();

    return useBaseQuery<BrandsParams, CommonResponse<Brand[]>, FetchError>({
        data,
        getMethod: params => getBrands(apiClient)(params),
        enabled,
    });
};

export const useBrand = (data: { id: number | string }, enabled = true) => {
    const apiClient = useAuthApiClient();

    return useBaseQuery<{ id: number | string }, CommonResponse<Brand>, FetchError>({
        data,
        getMethod: params => getBrand(apiClient)(params),
        enabled,
    });
};
